'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('custom-show', {
      url: '/custom/:type/:id',
      template: '<custom-show></custom-show>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/custom/show/custom-show.routes.js